import Vue from 'vue'; 
import Vuex from 'vuex';


Vue.use(Vuex);

const state = {
    bizCode:null,
    bizName:null,
    coverId:null
}
const mutations = {

}
const actions = {

}
const getters = {

}
// const mutations = {
//     viewDetails:(state, bizData) => {
//         state = JSON.stringify(Object.assign(state,bizData))
//         sessionStorage.setItem("state", state);
//     },
//     viewDetails2:(state2, bizData2) => {
//         state2 = JSON.stringify(Object.assign(state2,bizData2))
//         sessionStorage.setItem("state2", state2);
//     },
//     viewDetails3:(state3, bizData3) => {
//         state3 = JSON.stringify(Object.assign(state3,bizData3))
//         sessionStorage.setItem("state3", state3);
//     },
//     viewDetails4:(state4, bizData4) => {
//         state4 = JSON.stringify(Object.assign(state4,bizData4))
//         sessionStorage.setItem("state4", state4);
//     },
// }
// const actions = {
//
//
// }
// const getters = {
// 	getState: state => {
// 		return (state.bizCode && state.bizName && state.coverId) ? state : JSON.parse(sessionStorage.getItem('state'))
//     },
//     getState2: state2 => {
//         return (state2.cgCode && state2.cgName && state2.cgcoverId) ? state2 : JSON.parse(sessionStorage.getItem('state2'))
//     },
//     getState3: state3 => {
//         return (state3.zlCode && state3.zlName && state3.zlcoverId) ? state3 : JSON.parse(sessionStorage.getItem('state3'))
//     },
//     getState4: state4 => {
//         return (state4.htCode && state4.htName && state4.htcoverId) ? state4 : JSON.parse(sessionStorage.getItem('state4'))
//     },
// }


const myStore = new Vuex.Store({
    state,
    mutations,
    actions,
    getters
})

export default myStore

